import { Injectable } from '@angular/core';
import { TranslocoMissingHandler, TranslocoMissingHandlerData } from '@jsverse/transloco';

const GENERIC_MESSAGE_BY_LANG: Readonly<Record<string, string>> = {
  es: 'Ha ocurrido un problema inesperado. Inténtalo de nuevo en unos segundos.',
  en: 'Something went wrong. Please try again in a few seconds.',
  ca: 'S\'ha produït un problema inesperat. Torna-ho a provar d\'aquí a uns segons.',
};

@Injectable({ providedIn: 'root' })
export class SafeMissingTranslationHandler implements TranslocoMissingHandler {
  public handle(key: string, config: TranslocoMissingHandlerData): string {
    if (!config.prodMode) console.warn(`[Transloco] Missing translation for key: "${key}"`);

    // Never call `translate()` here: this handler runs from inside Transloco's own resolution
    // failure, and reentering it would either recurse into the same miss or mask a real backend
    // message with a second layer of fallback -- the copy below is a literal duplicate of
    // `commonErrorServer` in the three i18n JSON files, kept in sync by hand.
    return GENERIC_MESSAGE_BY_LANG[config.activeLang] ?? GENERIC_MESSAGE_BY_LANG['es'];
  }
}
